import { Typography } from '@mui/material'
import { FC, ReactNode } from 'react'

export const TitleAttention: FC<{ children: ReactNode }> = (props) => {
  return (
    <Typography
      variant="h3"
      sx={{
        padding: '0 0.5rem',
        borderLeft: '8px solid',
        borderLeftColor: 'primary.main',
        color: 'primary.dark',
        fontWeight: 'bold',
        width: 'fit-content',
      }}
    >
      {props.children}
    </Typography>
  )
}
